import StoryRiverView from 'src/components/StoryRiverView'
import { useSelector } from 'react-redux'
import { getViewByName } from 'src/features/views/ViewsSelector'
import useViewProps from 'src/hooks/useViewProps'

const TopStories = () => {
  const title = 'Top Stories'
  const view = useSelector(getViewByName('top stories')) || null
  const { viewsError, viewsLoading, handleViewMoreClick } = useViewProps()

  return (
    <StoryRiverView
      view={view}
      viewsError={viewsError}
      viewsLoading={viewsLoading}
      handleViewMoreClick={() => handleViewMoreClick('home', title)}
      title={title}
      viewMore={{
        to: '/river/top-stories',
        show: true,
        handleMore: title
      }}
      imagesLength="i < 3"
      showInterests={false}
      interestsClickable={true}
      tagsClickable={true}
    />
  )
}

export default TopStories
